// FILE: src/components/Footer.jsx
import { motion } from 'framer-motion';
import './footer.css';

export default function Footer() {
  return (
    <footer className="footer-container container-fluid px-4 py-5 bg-dark text-white">
  <div className="row">
    {/* Left Column – Contact Info */}
    <div className="col-md-6 mb-4 mb-md-0">
      <section className='hover-reveal'>
      <h5>Contact Us</h5>
      <p>S. No 19, Govindan Street, Ayyavoo Colony,<br />
         Aminjikarai, Chennai - 600029</p>
          <p><strong>✆</strong> +91-9676764491</p>
          <p><strong>📩</strong> info@oceancruise.in</p>
      </section>
    </div>

    {/* Right Column – Enquiry Form */}
    <div className="col-md-6">
      <h5>Enquiry</h5>
      <p>Get in touch with us for any queries or concerns.</p>
      <form
        action="https://formspree.io/f/mdkgrjrv"
        method="POST"
        className="footer-form"
      >
        <div className="row g-2">
          <div className="col-md-6">
            <input type="text" name="firstName" placeholder="First Name" required />
          </div>
          <div className="col-md-6">
            <input type="text" name="lastName" placeholder="Last Name" required />
          </div>
        </div>
        <input type="tel" name="phone" placeholder="Phone Number" className="mt-2" required />
        <input type="email" name="email" placeholder="Email Address" className="mt-2" required />
        <textarea name="message" placeholder="Your Message" rows="3" className="mt-2" required></textarea>
        <button type="submit" className="btn btn-primary mt-3">Submit</button>
      </form>
    </div>
  </div>
  <motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="footer-content">
        <p>&copy; 2025 Ocean Cruise All copy right reserved</p>
      </div>
    </motion.footer>
</footer>
  );
}


<motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="footer-content">
        <p>&copy; 2025 Ocean Cruise All copy right reserved</p>
      </div>
    </motion.footer>